<ng-container [ngSwitch]="block.type">
  <p class="message-renderer__text" *ngSwitchCase="messageBlockType.TEXT">{{ block.text || '' }}</p>

  <div
    class="message-renderer__markdown"
    *ngSwitchCase="messageBlockType.MARKDOWN"
    [innerHTML]="block.markdown | chatbotMarkdown"
  ></div>

  <div class="message-renderer__card" *ngSwitchCase="messageBlockType.TABLE">
    <p class="message-renderer__title">Table</p>
    <pre class="message-renderer__pre" *ngIf="block.data as tableData">{{ tableData | json }}</pre>
    <p class="message-renderer__empty" *ngIf="!block.data">No table data available.</p>
  </div>

  <div class="message-renderer__card message-renderer__card--warning" *ngSwitchCase="messageBlockType.WARNING">
    <p class="message-renderer__text">{{ block.text || 'Warning details are unavailable.' }}</p>
  </div>

  <div class="message-renderer__card" *ngSwitchCase="messageBlockType.SOURCE_REFERENCE">
    <p class="message-renderer__title">Sources</p>
    <ul class="message-renderer__list" *ngIf="block.sources?.length; else noSources">
      <li class="message-renderer__list-item" *ngFor="let source of block.sources; trackBy: trackBySourceReferenceId">
        {{ source.name || source.id }}
      </li>
    </ul>
    <ng-template #noSources>
      <p class="message-renderer__empty">No source references available.</p>
    </ng-template>
  </div>

  <div class="message-renderer__card" *ngSwitchCase="messageBlockType.METADATA">
    <p class="message-renderer__title">Metadata</p>
    <pre class="message-renderer__pre" *ngIf="block.metadata as metadataData">{{ metadataData | json }}</pre>
    <p class="message-renderer__empty" *ngIf="!block.metadata">No metadata available.</p>
  </div>

  <div class="message-renderer__card" *ngSwitchCase="messageBlockType.ACTIONS">
    <p class="message-renderer__title">Actions</p>
    <ul class="message-renderer__list" *ngIf="block.actions?.length; else noActions">
      <li class="message-renderer__list-item" *ngFor="let action of block.actions; trackBy: trackByActionId">
        {{ action.label }}
      </li>
    </ul>
    <ng-template #noActions>
      <p class="message-renderer__empty">No actions available.</p>
    </ng-template>
  </div>

  <div class="message-renderer__card" *ngSwitchCase="messageBlockType.WORKFLOW">
    <p class="message-renderer__title">Workflow</p>
    <p class="message-renderer__text">{{ block.workflowPreview?.title || 'Workflow preview is unavailable.' }}</p>
  </div>

  <div class="message-renderer__card" *ngSwitchCase="messageBlockType.CLARIFICATION">
    <p class="message-renderer__title">Clarification</p>
    <p class="message-renderer__text">
      {{ block.clarificationRequest?.question || 'Clarification details are unavailable.' }}
    </p>
  </div>

  <p class="message-renderer__fallback" *ngSwitchDefault>Content type is not supported yet.</p>
</ng-container>
